var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 11.3368L22 23.2737L37.4687 11.3368M17.7025 21.9999L7.5625 33.0403M36.4375 32.136L26.2962 21.9999M9.625 34.8332C7.34683 34.8332 5.5 32.8898 5.5 30.4925V13.5072C5.5 11.1099 7.34683 9.1665 9.625 9.1665H34.375C36.6532 9.1665 38.5 11.1099 38.5 13.5072V30.4925C38.5 32.8898 36.6532 34.8332 34.375 34.8332H9.625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.35720fc463018d4ea6340b7ed6d97429.svg";
export { ForwardRef as ReactComponent };